import React, { useContext } from 'react';
import Context from './Context/SessionContext';
import IdleTimer from 'react-idle-timer';
// import APP from '../../tools/AppRoutes';
import APP from '../tools/AppRoutes';
import { withRouter } from "react-router-dom";

const Afk = ({ history }) => {
    const { logout } = useContext(Context);

    const onActive = () => { }
    const onAction = () => { }

    const onIdle = () => {
        history.push(APP.INDEX);
        localStorage.clear();
        logout();
    }

    return (
        <IdleTimer
            element={document}
            onActive={onActive}
            onIdle={onIdle}
            onAction={onAction}
            debounce={250}
            timeout={1000 * 60 * 15} //milisegundos * segundos x minuto
        />
    )
}

export default withRouter(Afk);